var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReminder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 14,
    viewBox: "0 0 32 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12876_58907)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    fill: "#E3A11F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 10,
    height: 14,
    fill: "#F4DAA6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 10,
    height: 14,
    fill: "#F4DAA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12876_58907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 14,
    rx: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder1);
export default __webpack_public_path__ + "static/media/Reminder1.cdae754efbcc1df6b9406b4b909c2ee0.svg";
export { ForwardRef as ReactComponent };